import * as React from 'react';
const SvgMagicWand = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    viewBox="0 0 18 18"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.422.238a.345.345 0 0 1 .656 0l.253.782c.1.308.341.549.649.649l.782.253a.345.345 0 0 1 0 .656l-.782.253c-.308.1-.549.341-.649.649l-.253.782a.345.345 0 0 1-.656 0l-.253-.782c-.1-.308-.341-.549-.649-.649l-.781-.253a.345.345 0 0 1 0-.656l.781-.253c.308-.1.549-.341.649-.649zM3.828 2.488a.345.345 0 0 0-.656 0l-.253.782c-.1.308-.341.549-.649.649l-.782.253a.345.345 0 0 0 0 .656l.782.253c.308.1.549.341.649.649l.253.782a.345.345 0 0 0 .656 0l.253-.782c.1-.308.341-.549.649-.649l.782-.253a.345.345 0 0 0 0-.656l-.782-.253c-.308-.1-.549-.341-.649-.649zm11 9a.345.345 0 0 0-.656 0l-.253.782c-.1.308-.341.549-.649.649l-.781.253a.345.345 0 0 0 0 .656l.781.253c.308.1.549.341.649.649l.253.781a.345.345 0 0 0 .656 0l.253-.781c.1-.308.341-.549.649-.649l.782-.253a.345.345 0 0 0 0-.656l-.782-.253c-.308-.1-.549-.341-.649-.649zm-11.62 4.704 6.254-6.255-1.414-1.414-6.255 6.255a1 1 0 1 0 1.414 1.414m8.484-8.485-1.169 1.17-1.414-1.415 1.17-1.17a1 1 0 1 1 1.413 1.415m1.061-2.475a2.5 2.5 0 0 0-3.535 0L.732 13.718a2.5 2.5 0 1 0 3.536 3.535l8.485-8.485a2.5 2.5 0 0 0 0-3.536"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMagicWand;
